// Brand-styled 404. Italian voice, deliberate paper-and-rame palette.

import {
  Button,
  Surface,
  TopBar,
  Wordmark,
} from "@/design-system";
import { useBranding } from "@/lib/branding";
import { useScreenTitle } from "@/lib/use-screen-title";

export interface NotFoundProps {
  onHome: () => void;
}

export function NotFound({ onHome }: NotFoundProps) {
  useScreenTitle("Pagina non trovata");
  const { displayName } = useBranding();
  return (
    <Surface>
      <TopBar left={<Wordmark size={16} sub displayName={displayName} />} right={null} />

      <section className="px-6 pt-16 pb-16 max-w-md mx-auto text-center">
        <p className="font-mono text-[11px] uppercase tracking-[1.4px] text-ink-faint mb-5">
          404
        </p>

        <h1 className="font-serif text-[36px] leading-[1.1] tracking-[-0.4px] text-ink m-0 font-medium">
          Pagina non trovata.
        </h1>

        <p className="mt-5 font-sans text-[16px] leading-[1.55] text-ink-muted">
          Il link che hai seguito non porta a nulla. Capita. Torna pure
          all&apos;inizio — MIMIR ti aspetta.
        </p>

        <div className="mt-8">
          <Button variant="primary" onClick={onHome}>
            Torna alla pagina iniziale
          </Button>
        </div>
      </section>
    </Surface>
  );
}
